class IdGenerator {
  constructor(prefix) {
    this.state = {
      prefix: prefix || '',
      i: 0,
    };
  }

  getCurrent() {
    return `${this.state.prefix}-${this.state.i}`;
  }

  getCurrentIndex() {
    return this.state.i;
  }

  getNext() {
    const ret = this.getCurrent();
    this.state.i += 1;
    return ret;
  }
}

export default IdGenerator;
